// extracted by mini-css-extract-plugin
export default {"btop":"c398fd9b83 c2ce086dad _57c4417536","icon":"_3dea37104b _64c75da1c2","btoppink":"_3659358a00 _5f87128e9b"};